<my-content placeholder="navigation">
  <!-- <div class="form-group mt-2" style="display: none">
    <div class="form-check">
      <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked="true"
        [(ngModel)]="options.autoClose" />
      <label for="autoClose">Auto close alert after three seconds</label>
    </div>
  </div> -->
  <div class="container-fluid">
    <div class="page-heading d-flex align-items-center justify-content-between my-4 px-2">
      Corporate Decision
      <button class="btn btn-outline-primary" title="Go Back" (click)="goBack()">
        <i class="fa fa-arrow-left"></i> Back
      </button>
    </div>
    <form [formGroup]="addFormDecision" (ngSubmit)="onSubmit(addFormDecision.value)">
    <div class="card rounded-4 border-0">
      <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label for="DecisionPoint">{{Captions?.decision_point}} <span class="text-danger">*</span> </label>
                <input type="text" id="DecisionPoint" class="form-control" formControlName="Description" autofocus
                  autocomplete="off" [placeholder]="'Enter '+Captions.decision_point" name="Description" required />
                  @if (f.Description.touched && f.Description.invalid) {
                    <div class="text-danger">
                      @if (f.Description.errors?.['required']) {
                        <span>{{Captions?.decision_point}} is required.</span>
                      }
                    </div>
                  }
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label for="DateofDecision">{{Captions?.date_of_decision}} <span class="text-danger">*</span> </label>
                <mat-form-field class="fullwidth" appearance="outline">
                  <input matInput [readonly]="!editable" [min]="minDate" formControlName="DateofDecision"
                    [max]="maxDate" [matDatepicker]="picker4" placeholder="Choose a date" />
                  <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                  <mat-datepicker #picker4></mat-datepicker>
                </mat-form-field>
                @if (f.DateofDecision.touched && f.DateofDecision.invalid) {
                  <mat-error>
                    @if (f.DateofDecision.errors?.['required']) {
                      {{Captions?.date_of_decision}} is required.
                    }
                  </mat-error>
                }
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label for="TargetDate">{{Captions?.target_date}} <span class="text-danger">*</span> </label>
                <mat-form-field class="fullwidth" appearance="outline">
                  <input matInput [readonly]="!editable" [min]="minDate" formControlName="TargetDate" [max]="maxDate"
                    [matDatepicker]="picker2" placeholder="Choose a date" />
                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
                @if (f.TargetDate.touched && f.TargetDate.invalid) {
                  <mat-error>
                    @if (f.TargetDate.errors?.['required']) {
                      {{Captions?.target_date}} is required.
                    }
                  </mat-error>
                }
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label for="DueDate">{{Captions?.due_date_if_any}}</label>
                <mat-form-field class="fullwidth" appearance="outline">
                  <input matInput [readonly]="!editable" [min]="minDate" formControlName="DueDate" [max]="maxDate"
                    [matDatepicker]="picker3" placeholder="Choose a date" />
                  <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                  <mat-datepicker #picker3></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label for="BriefFacts">{{Captions?.brief_facts}} <span class="text-danger">*</span> </label>
                <textarea type="text" id="BriefFacts" class="form-control" formControlName="BriefFacts" autocomplete="off"
                  [placeholder]="'Enter '+Captions?.brief_facts" name="Description" rows="3"></textarea>
                  @if (f.BriefFacts.touched && f.BriefFacts.invalid) {
                    <div class="text-danger">
                      @if (f.BriefFacts.errors?.['required']) {
                        <span>{{Captions?.brief_facts}} is required.</span>
                      } 
                    </div>
                  }
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label for="ActionType">{{Captions?.type_of_action}} <span class="text-danger">*</span> </label>
                <ng-select [items]="typeOfAction" [clearable]="false" [multiple]="false" formControlName="ActionType" 
                bindLabel="MainDescr" [selectableGroup]="true" [closeOnSelect]="true" bindValue="hdID" 
                 [placeholder]="'Select '+Captions?.type_of_action">
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    {{item.MainDescr}}
                  </ng-template>
                </ng-select>

                  @if (f.ActionType.touched && f.ActionType.invalid) {
                    <div class="text-danger">
                      @if (f.ActionType.errors?.['required']) {
                        <span>{{Captions?.type_of_action}} is required.</span>
                      }
                    </div>
                  }
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label for="ActionTakenBy">{{Captions?.action_taken_by}} <span class="text-danger">*</span> </label>
                <textarea type="text" id="ActionTakenBy" class="form-control" formControlName="ActionTakenBy"
                  autocomplete="off" [placeholder]="'Enter '+Captions?.action_taken_by" name="Description" rows="3"></textarea>
                  @if (f.ActionTakenBy.touched && f.ActionTakenBy.invalid) {
                    <div class="text-danger">
                      @if (f.ActionTakenBy.errors?.['required']) {
                        <span>{{Captions?.action_taken_by}} is required.</span>
                      }
                    </div>
                  }
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label>{{Captions?.filing_party}} <span class="text-danger">*</span> </label>
                <ng-select [items]="filteredFillingParty" [multiple]="true" [closeOnSelect]="false" bindLabel="Name"
                  bindValue="ID" formControlName="fillingPartyName" [placeholder]="'Select '+Captions?.filing_party">

                  <ng-template ng-option-tmp let-item="item">
                    {{ item.Name }}
                  </ng-template>

                </ng-select>
                @if (f.fillingPartyName.touched && f.fillingPartyName.invalid) {
                  <div class="text-danger">
                    @if (f.fillingPartyName.errors?.['required']) {
                      <span>{{Captions?.filing_party}} is required.</span>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label>{{Captions?.opposite_party}} <span class="text-danger">*</span> </label>
                <ng-select [items]="filteredOppositeParty" [multiple]="true" [closeOnSelect]="false" bindLabel="Name"
                  bindValue="ID" formControlName="oppositePartyName" [placeholder]="'Select '+Captions?.opposite_party">

                  <ng-template ng-option-tmp let-item="item">
                    {{ item.Name }}
                  </ng-template>

                </ng-select>
                @if (f.oppositePartyName.touched && f.oppositePartyName.invalid) {
                  <div class="text-danger">
                    @if (f.oppositePartyName.errors?.['required']) {
                      <span>{{Captions?.opposite_party}} is required.</span>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label for="Attachments">{{Captions?.attachments_if_any}}</label>
                <input type="file" id="Attachments" formControlName="browseFiles" (change)="onSelectFile($event)"
                  multiple />
              </div>
            </div>
          </div>
          
        </div>
      </div>
      @if ( RightsID.includes('202038001') || RightsID.includes('20203821')) {
        <div class="d-flex align-items-center justify-content-center mt-4">
          <button class="btn btn-primary submit-btn" [type]="DisplaySaveNoticeButton" [disabled]="clicked">
            {{ HeaderButtonCaption }}
          </button>
        </div>
      }
      
      <!-- @if (false) {
      <div class="">
        <table width="100%" class="LMtable_lite entry">
          <tr>
            <td width="15%">
              Decision Point <span style="color: red">*</span>
            </td>
            <td width="35%">
              <div class="col-sm-11">
                <input class="form-control" formControlName="Description" autofocus autocomplete="off"
                  placeholder="Enter Decision Point" name="Description" type="text" value="" />
              </div>
            </td>
            <td width="15%">
              Date Of Decision <span style="color: red">*</span>
              &nbsp;
            </td>
            <td>
              &nbsp;
              <div class="col-sm-11">
                <mat-form-field class="fullwidth">
                  <input matInput [readonly]="!editable" [min]="minDate" formControlName="DateofDecision"
                    [max]="maxDate" [matDatepicker]="picker4" placeholder="Choose a date" />
                  <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                  <mat-datepicker #picker4></mat-datepicker>
                </mat-form-field>
              </div>
              <label style="display: none" *ngFor="let urldata of fileurls">{{
                urldata
                }}</label>
            </td>
          </tr>
          <tr>
            <td width="15%">Brief Facts <span style="color: red">*</span></td>
            <td width="35%">
              <div class="col-sm-11">
                <input class="form-control" formControlName="BriefFacts" autocomplete="off"
                  placeholder="Brief Facts" name="Description" type="text" value="" />
              </div>
            </td>
            <td width="15%">Target Date <span style="color: red">*</span></td>
            <td width="35%">
              <div class="col-sm-11">
                <mat-form-field class="fullwidth">
                  <input matInput [readonly]="!editable" [min]="minDate" formControlName="TargetDate"
                    [max]="maxDate" [matDatepicker]="picker2" placeholder="Choose a date" />
                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
              </div>
            </td>
          </tr>
          <tr>
            <td>Due Date (if Any)</td>
            <td>
              <div class="col-sm-11">
                <mat-form-field class="fullwidth">
                  <input matInput [readonly]="!editable" [min]="minDate" formControlName="DueDate" [max]="maxDate"
                    [matDatepicker]="picker3" placeholder="Choose a date" />
                  <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                  <mat-datepicker #picker3></mat-datepicker>
                </mat-form-field>
              </div>
            </td>
            <td width="15%">
              Type of Action <span style="color: red">*</span>
            </td>
            <td width="35%">
              <div class="col-sm-11">
                <input class="form-control" formControlName="ActionType" autocomplete="off"
                  placeholder="Enter Type of Action" name="Description" type="text" value="" />
              </div>
            </td>
          </tr>
          <tr>
            <td width="15%">
              Action Taken By <span style="color: red">*</span>
            </td>
            <td width="35%">
              <div class="col-sm-11">
                <input class="form-control" formControlName="ActionTakenBy" autocomplete="off"
                  placeholder="Enter Action Taken By " name="Description" type="text" value="" />
              </div>
            </td>
            <td width="15%">
              <a routerLink="/addorgcontact/0/0" target="_blank">Filling Party</a>
            </td>
            <td width="35%">
              <div class="col-sm-11">
                <ng-select [items]="FillingOppoParty" [clearable]="false" [multiple]="true"
                  formControlName="fillingPartyName" bindLabel="Name" [selectableGroup]="true"
                  [closeOnSelect]="true" bindValue="ID" [(ngModel)]="selectedFillingParty">
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    {{ item.Name }}
                  </ng-template>
                </ng-select>
              </div>
            </td>
          </tr>
          <tr>
            <td width="15%">
              <a routerLink="/addorgcontact/0/0" target="_blank">Opposite Party</a>
            </td>
            <td width="35%">
              <div class="col-sm-11">
                <ng-select [items]="FillingOppoParty" [clearable]="false" [multiple]="true"
                  formControlName="oppositePartyName" bindLabel="Name" [selectableGroup]="true"
                  [closeOnSelect]="true" bindValue="ID" [(ngModel)]="selectedOppositeParty">
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    {{ item.Name }}
                  </ng-template>
                </ng-select>
              </div>
            </td>
            <td width="15%">Attachments (if Any)</td>
            <td width="35%">
              <div class="col-sm-11">
                <input type="file" formControlName="browseFiles" (change)="onSelectFile($event)" multiple />
              </div>
            </td>
          </tr>
        </table>
      </div>
      } -->
      <!-- <div class="col-sm-12">
        <div class="col-sm-5"></div>

        <div *ngIf="
        this.RightsID.includes('202038001') ||
          this.RightsID.includes('202038021');
        then HeaderButtonLink;
        else HeaderButton
      "></div>
        <ng-template #HeaderButtonLink>
          <input class="btn btn-primary col-sm-2" [type]="DisplaySaveNoticeButton" value="{{ HeaderButtonCaption }}"
            [disabled]="clicked" />
        </ng-template>
        <ng-template #HeaderButton>
          <div class="col-sm-2">&nbsp;</div>
        </ng-template>

      </div> -->

      <!-- <div class="col-sm-12">&nbsp;</div> -->
    </form>
  </div>
</my-content>
<my-content placeholder="main"> </my-content>